import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/trainers';
const filter = (filter) => filter ? '&filter=' + filter : '';
const state = {
    trainers: [],
    trainer: null,
    topics: null,
}
const getters = {
    trainers: (state) => state.trainers,
    trainer: (state) => state.trainer,
    trainerTopics: (state) => state.topics,
}
const actions = {
    async fetchTrainers({ commit }, search) {
        const response = await axios.get(API_URL + '?expand=contact' + filter(search));
        commit('setTrainers', response.data.items);    
    },
    async fetchTrainer({ dispatch, commit }, id) {
        const response = await axios.get(API_URL + '/' + id + '/by-ref?expand=contact');
        commit('setTrainer', response.data);
    },
    async fetchTrainerTopics({ commit }, ids) {
        const response = await axios.get(API_URL + '/' + ids.trainerId + '/topics/' + ids.seminarId);
        commit('setTopics', response.data);
    }
}
const mutations = {
    setTrainers: (state, trainers) => state.trainers = trainers,
    setTrainer: (state, trainer) => state.trainer = trainer,
    setTopics: (state, topics) => state.topics = topics,
}

export default {
    state,
    getters,
    actions,
    mutations,
}